import classNames from 'classnames'
import { useEffect } from 'react'
import css from './styles.scss'

interface EmbedSocialMediaProps {
  channel: 'Facebook' | 'Giphy' | 'Instagram' | 'TikTok' | 'Twitter' | 'Youtube'
  postTitle?: string
  embedCode: string
}

const EmbedSocialMedia: React.FC<EmbedSocialMediaProps> = ({
  channel,
  embedCode,
}) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !window) return
    const container = document.getElementById('embed-container')
    if (container) {
      container.innerHTML = embedCode

      const scripts = Array.from(container.querySelectorAll('script'))
      scripts.forEach((oldScript) => {
        const newScript = document.createElement('script')
        Array.from(oldScript.attributes).forEach((attr) =>
          newScript.setAttribute(attr.name, attr.value)
        )
        newScript.appendChild(document.createTextNode(oldScript.innerHTML))
        if (oldScript.parentNode) {
          oldScript.parentNode.replaceChild(newScript, oldScript)
        }
      })
    }
  }, [embedCode])

  if (typeof window === 'undefined' || !window) return <></>

  return (
    <div
      className={classNames(css.EmbedSocialMedia__container, {
        [css['EmbedSocialMedia__container--youtube']]: channel === 'Youtube',
        [css['EmbedSocialMedia__container--tiktok']]: channel === 'TikTok',
      })}
      id="embed-container"
    />
  )
}

export default EmbedSocialMedia
